module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "creation"
    }
  }, [_c('input-container', {
    attrs: {
      "text": "Hauteur",
      "value": "updatedNewHeight",
      "placeholder": "insert a height"
    },
    on: {
      "input": _vm.height
    }
  }), _vm._v(" "), _c('input-container', {
    attrs: {
      "text": "Largeur",
      "value": "updatedNewWidth",
      "placeholder": "insert a width"
    },
    on: {
      "input": _vm.width
    }
  }), _vm._v(" "), _c('bouton', {
    attrs: {
      "className": "button-create",
      "text": "Create grid"
    },
    on: {
      "click": _vm.click
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a31dadfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Creation/Creation.vue
// module id = 28
// module chunks = 1